import 'typeahead.js';
import Bloodhound from 'typeahead.js/dist/bloodhound';

export default {
    vacancies: new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: `/technical/typeahead-vacancies?query=%QUERY`,
            wildcard: '%QUERY'
        }
    }),

    locations: new Bloodhound({
        datumTokenizer: datum => Bloodhound.tokenizers.whitespace(Object.values(datum).join(' ')),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: '/technical/list-locations?prefetch=job_search',
        remote: {
            url: `/technical/typeahead-locations?query=%QUERY`,
            wildcard: '%QUERY'
        }
    }),

    compile: (data) => {
        let retVal = data.city ?? '';

        if (retVal) {
            if (data.hasOwnProperty('county') && data.county)
                retVal ? retVal += `, ${data.county}` : retVal = data.county;

            if (data.hasOwnProperty('state') && data.state)
                retVal ? retVal += `, ${data.state}` : retVal = data.state;

            if (data.hasOwnProperty('country') && data.country)
                retVal ? retVal += `, ${data.country}` : retVal = data.country;

            if (data.hasOwnProperty('postcode') && data.postcode)
                retVal += ` ${data.postcode}`;
        } else {
            const country = data.country ?? '';
            Object.keys(data).forEach(key => {
                if (key !== 'country' && ! key.startsWith('_')) retVal ? retVal += `, ${data[key]}` : retVal = data[key];
            })
            retVal = country ? `${retVal}, ${country}` : retVal;
        }


        retVal = retVal.replace(/^,\s*/, '');
        return `<div>${retVal}</div>`;
    },

    displayValue: (data) => {
        if (data.city) {
            return data.city;
        }

        for (const key in data) {
            if (key !== 'country' && !key.startsWith('_') && data[key]) {
                return data[key];
            }
        }

        return data.country ?? '';
    },

    initVacanciesAutocomplete(nodeSelector) {
        $(nodeSelector).typeahead(
            {
                minLength: 1,
                highlight: true
            },
            {
                name: 'job-title',
                display: 'title',
                limit: 10,
                source: this.vacancies
            }
        );
    },

    initLocationAutocomplete(nodeSelector) {
        function compareSuggestionNodes(a, b, s) {
            s = s.toLowerCase();
            const aStartsWith = a.innerText.toLowerCase().startsWith(s),
                bStartsWith = b.innerText.toLowerCase().startsWith(s);

            if (aStartsWith && !bStartsWith) return -1;
            if (!aStartsWith && bStartsWith) return 1;

            return 0;
        }

        $(nodeSelector).typeahead('destroy');
        $(nodeSelector).typeahead(
            {
                minLength: 2,
                highlight: true,
            },
            {
                name: 'locations',
                display: this.displayValue,
                limit: 15,
                source: this.locations,
                templates: {suggestion: this.compile,}
            }
        )
            .bind('typeahead:select', function(ev, suggestion) {
                const rawVal = Object.values(suggestion).join(' '),
                    evt = new CustomEvent("new-location", { detail: rawVal });

                window.dispatchEvent(evt);

                if (suggestion.hasOwnProperty('id')) {
                    const locationId = suggestion.hasOwnProperty('country')
                        ? suggestion.id
                        : 'uk-' + suggestion.id;

                    $(ev.target).parents('form').find('input[name="location-id"]').val(locationId);
                    $(ev.target).parents('form').find('input[name="location"]').val(suggestion.city);
                } else {
                    $(ev.target).parents('form').find('input[name="location-id"]').val('');
                    $(ev.target).parents('form').find('input[name="location"]').val(rawVal);
                }
            })
            .bind('typeahead:render', function(ev, suggestion, async, dsName) {
                if(suggestion && suggestion.hasOwnProperty('id')) {
                    const val = suggestion.hasOwnProperty('country')
                        ? suggestion.id + ':' + suggestion.city
                        : 'uk-' + suggestion.id + ':' + suggestion.city;

                    sessionStorage.setItem("jobSearchSuggestion", val);
                }
            })
            .bind('typeahead:rendered', function(ev, ...suggestions) {
                if (! ev.currentTarget.id?.includes('location') || ! suggestions[0]?.hasOwnProperty('city')) return;

                const list = $(ev.target).siblings('.tt-menu').find('.tt-dataset');

                if (!list.length) return;

                [...list[0].children]
                    .sort((a, b) => compareSuggestionNodes(a, b, ev.currentTarget.value))
                    .forEach(node => list.append(node));
            });
    },

    init() {
        this.initVacanciesAutocomplete('.search-input[name="job-title"]');
        this.initLocationAutocomplete('.search-input[name="location-needle"]');
        this.initLocationAutocomplete('.search-input[name="location"]');
        this.initVacanciesAutocomplete('.original-search-input[name="job-title"]');
        this.initLocationAutocomplete('.original-search-input[name="location-needle"]');
        this.initLocationAutocomplete('.original-search-input[name="location"]');
    },
};
